module.exports = __webpack_public_path__ + "img/bbt_blockbasetkn.8fbfb4a.png";